import { api2 , apiUpload } from './ApiService';

export default class MobilePackageService {
    

    static async search(key,page,perpage){
        let data ={
            key: key,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/mobile/package/search`,data)
        return response.data
    }
 
    static async create(data){
        let response = await apiUpload.post(`/api/v1/mobile/package/create`,data)
        return response.data
    }
    static async update(data){
        let response = await apiUpload.post(`/api/v1/mobile/package/update`,data)
        return response.data
    }
    static async delete(data){
        let response = await api2.post(`/api/v1/mobile/package/delete`,data)
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/MobilePackageService.js